import { getBaseUrl } from "@/utils/utils"

const BASE_URL = getBaseUrl()
const COMMON_API_ENDPOINT = `ext/jcp-${process.env.VUE_APP_FEEDBACK_VERTICAL}/application/v1.0`

export const API_URLS = {
  // getWidgetConfigUrl: () => {
  //   return `${BASE_URL}/${COMMON_API_ENDPOINT}/op/config/review-validation`
  // },
  getWidgetConfigUrl: () => {
    return `${BASE_URL}/${COMMON_API_ENDPOINT}/op/config/bulkConfig`
  },
  getReviewUrl: () => {
    return `${BASE_URL}/${COMMON_API_ENDPOINT}/op/config/review-validation`
  },
  getUserReviewUrl: (productId) => {
    return `${BASE_URL}/${COMMON_API_ENDPOINT}/review/user/product/${productId}`
  },
  getProductStatsUrl: (productId) => {
    return `${BASE_URL}/${COMMON_API_ENDPOINT}/op/review/product-statistics/${productId}`
  },
  getProductReviewsUrl: (productId) => {
    return `${BASE_URL}/${COMMON_API_ENDPOINT}/op/review/product/${productId}`
  },
  getProductReviewImagesUrl: () => {
    return `${BASE_URL}/${COMMON_API_ENDPOINT}/op/review/images`
  },
  getAddReviewUrl: () => {
    return `${BASE_URL}/${COMMON_API_ENDPOINT}/review/product`
  },
  getEditReviewUrl: (reviewId) => {
    return `${BASE_URL}/${COMMON_API_ENDPOINT}/review/product/${reviewId}`
  },
  getReviewUpdateVoteCountUrl: () => {
    return `${BASE_URL}/${COMMON_API_ENDPOINT}/review/vote/count`
  },
  getQnAUpdateVoteCountUrl: () => {
    return `${BASE_URL}/${COMMON_API_ENDPOINT}/q-and-a/vote/count`
  },
  getSignedImageUrl: () => {
    return `${BASE_URL}/${COMMON_API_ENDPOINT}/file/generateSignedURLInternal`
  },
  getProductQnAUrl: (productId) => {
    return `${BASE_URL}/${COMMON_API_ENDPOINT}/op/q-and-a/product/${productId}`
  },
  getAddQuestionUrl: () => {
    return `${BASE_URL}/${COMMON_API_ENDPOINT}/q-and-a/question`
  },
  getAddAnswerUrl: () => {
    return `${BASE_URL}/${COMMON_API_ENDPOINT}/q-and-a/answer`
  },
  getVerifiedPurchaseUrl: (articleId) => {
    return `${BASE_URL}/${COMMON_API_ENDPOINT}/review/verifyPurchase/${articleId}`
  },
  getAllAnswersForQuestionUrl: (questionId) => {
    return `${BASE_URL}/${COMMON_API_ENDPOINT}/op/q-and-a/question/${questionId}`
  },
}
